import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import AopsHeader from '../../components/apos/AopsHeader'
import CaseTrackBoard from '../../components/apos/case/CaseTrackBoard'
import {
  scheduleBoardRefetchTrigger,
  standaloneScheduleViewUserId,
  trackerBoardRefetchTrigger,
} from '../../store/standaloneSchedule'
import ScheduleBoardSection from './components/ScheduleBoardSection'
import StandaloneFastPopup from './components/StandaloneFastPopup'
import StandaloneRoutineItemPopup from './components/StandaloneRoutineItemPopup'
import StandaloneRoutinePopup from './components/StandaloneRoutinePopup'
import StandaloneScheduledTaskPopup from './components/StandaloneScheduledTaskPopup'
import StandaloneWatchdogPopup from './components/StandaloneWatchdogPopup'
import StandaloneWatchdogTaskPopup from './components/StandaloneWatchdogTaskPopup'
import TrackerBoardSection from './components/TrackerBoardSection'
import './StandaloneSchedulePage.scss'

const StandaloneSchedulePage = () => {
  const { studio, team, id } = useParams()
  const setViewUserId = useSetRecoilState(standaloneScheduleViewUserId)
  const setTrackerBoardRefetch = useSetRecoilState(trackerBoardRefetchTrigger)
  const setScheduleBoardRefetch = useSetRecoilState(scheduleBoardRefetchTrigger)
  const [selectedRoutineItemId, setSelectedRoutineItemId] = useState(null)

  useEffect(() => {
    setViewUserId(id ?? null)
    return () => setViewUserId(null)
  }, [id, setViewUserId])
  const [selectedScheduledItemId, setSelectedScheduledItemId] = useState(null)
  const [isRoutinePopupOpen, setIsRoutinePopupOpen] = useState(false)
  const [isFastPopupOpen, setIsFastPopupOpen] = useState(false)
  const [isRoutineItemPopupOpen, setIsRoutineItemPopupOpen] = useState(false)
  const [isScheduledPopupOpen, setIsScheduledPopupOpen] = useState(false)
  const [isScheduledItemPopupOpen, setIsScheduledItemPopupOpen] =
    useState(false)
  const [isWatchdogPopupOpen, setIsWatchdogPopupOpen] = useState(false)
  const [selectedWatchdogId, setSelectedWatchdogId] = useState(null)
  const [isWatchdogTaskPopupOpen, setIsWatchdogTaskPopupOpen] = useState(false)
  const [selectedTaskId, setSelectedTaskId] = useState(null)
  const [selectedTask, setSelectedTask] = useState(null)

  const handleOpenFastPopup = () => {
    setIsFastPopupOpen(true)
  }

  const handleOpenRoutinePopup = () => {
    setIsRoutinePopupOpen(true)
  }

  // 트래커 보드 & 스케쥴 보드 refetch (루틴/Fast 업무 생성 시)
  const handleRefetchTrackerBoard = () => {
    setTrackerBoardRefetch((prev) => prev + 1)
    setScheduleBoardRefetch((prev) => prev + 1)
  }

  const handleOpenRoutineItemPopup = (id) => {
    setSelectedRoutineItemId(id)
    setIsRoutineItemPopupOpen(true)
  }

  const handleOpenScheduledItemPopup = (id) => {
    setSelectedScheduledItemId(id)
    setIsScheduledItemPopupOpen(true)
  }

  const handleOpenScheduledPopup = () => {
    setIsScheduledPopupOpen(true)
  }

  return (
    <>
      <div className="standalone-schedule-page">
        <AopsHeader active="schedule-dashboard" />

        {/* 트래커 보드 */}
        <TrackerBoardSection
          title="Ops. 보드"
          subtitle="금일과 금주의 현재업무와 예정업무를 파악할 수 있어요"
          buttonText="Fast 업무 생성"
          onOpenTaskPopup={handleOpenFastPopup}
          setIsWatchdogPopupOpen={setIsWatchdogPopupOpen}
          setSelectedWatchdogId={setSelectedWatchdogId}
          setIsWatchdogTaskPopupOpen={setIsWatchdogTaskPopupOpen}
          setSelectedTaskId={setSelectedTaskId}
          setSelectedTask={setSelectedTask}
          onRefetch={handleRefetchTrackerBoard}
        />
        <div style={{ marginBottom: '10px' }} />
        {/* 케이스  보드 */}
        <CaseTrackBoard />
        <div style={{ marginBottom: '10px' }} />
        {/* 스케쥴 보드 */}
        <ScheduleBoardSection
          title="Scheduled 보드"
          subtitle="오늘 해야 할 루틴 업무를 명확히 하고 하나씩 완료해 나가세요"
          buttonText="Scheduled 업무 생성"
          handleOpenScheduledPopup={handleOpenScheduledPopup}
          buttonText2="Routine 업무 생성"
          onOpenRoutinePopup={handleOpenRoutinePopup}
          onOpenRoutineItemPopup={handleOpenRoutineItemPopup}
          onOpenScheduledItemPopup={handleOpenScheduledItemPopup}
        />
      </div>

      {/* 모달 */}
      <StandaloneRoutinePopup
        open={isRoutinePopupOpen}
        onClose={() => setIsRoutinePopupOpen(false)}
        onSuccess={handleRefetchTrackerBoard}
      />
      <StandaloneFastPopup
        open={isFastPopupOpen}
        onClose={() => setIsFastPopupOpen(false)}
        onSuccess={handleRefetchTrackerBoard}
      />
      <StandaloneScheduledTaskPopup
        open={isScheduledPopupOpen}
        onClose={() => setIsScheduledPopupOpen(false)}
        onSuccess={handleRefetchTrackerBoard}
      />

      {/* 스케쥴 보드 모달 */}
      <StandaloneRoutineItemPopup
        id={selectedRoutineItemId}
        open={isRoutineItemPopupOpen}
        onClose={() => {
          setIsRoutineItemPopupOpen(false)
          setSelectedRoutineItemId(null)
        }}
        onSuccess={handleRefetchTrackerBoard}
      />
      <StandaloneScheduledTaskPopup
        id={selectedScheduledItemId}
        open={isScheduledItemPopupOpen}
        onClose={() => {
          setIsScheduledItemPopupOpen(false)
          setSelectedScheduledItemId(null)
        }}
        onSuccess={handleRefetchTrackerBoard}
      />

      <StandaloneWatchdogPopup
        open={isWatchdogPopupOpen}
        onClose={(opts) => {
          setIsWatchdogPopupOpen(false)
          setSelectedWatchdogId(null)
          if (opts?.deleted) setTimeout(() => handleRefetchTrackerBoard(), 0)
        }}
        watchdogId={selectedWatchdogId}
        onSuccess={handleRefetchTrackerBoard}
        onOpenTaskPopup={() => {
          setSelectedTaskId(null)
          setSelectedTask(null)
          setIsWatchdogTaskPopupOpen(true)
        }}
        onOpenTaskEditPopup={(task) => {
          setSelectedTaskId(task.id)
          setSelectedTask(task)
          setIsWatchdogTaskPopupOpen(true)
        }}
      />
      <StandaloneWatchdogTaskPopup
        open={isWatchdogTaskPopupOpen}
        onClose={() => {
          setIsWatchdogTaskPopupOpen(false)
          setSelectedTaskId(null)
          setSelectedTask(null)
        }}
        watchdogId={selectedWatchdogId}
        taskId={selectedTaskId}
        task={selectedTask}
        onSuccess={handleRefetchTrackerBoard}
      />
    </>
  )
}

export default StandaloneSchedulePage
